/* ------------------------------------------------------------------
   ANA-LAYER: Load-More auf Kategorieseiten
   Gehoert zu snippets/ana-load-more.liquid + assets/ana-load-more.css

   Prinzip (Progressive Enhancement):
   Der Button ist im HTML ein echter Link auf ?page=n. Dieses Skript faengt
   den Klick ab und haengt die naechste Seite per fetch an das Raster an.
   Faellt irgendetwas aus (Netzwerk, unerwartetes Markup), wird der Link
   ganz normal aufgerufen — der Nutzer landet auf der naechsten Seite.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var GRID_SELECTOR = '.collection-listing .product-grid';

  class AnaLoadMore extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.grid = document.querySelector(GRID_SELECTOR);
      this.countEl = this.querySelector('[data-lm-count]');
      this.barEl = this.querySelector('[data-lm-bar]');
      this.btn = this.querySelector('[data-lm-btn]');

      this.total = parseInt(this.dataset.total, 10) || 0;
      this.pageSize = parseInt(this.dataset.pageSize, 10) || 0;
      this.currentPage = parseInt(this.dataset.currentPage, 10) || 1;

      this.addPreviousLink();

      if (!this.grid || !this.btn) return;

      this.btn.addEventListener('click', this.onClick.bind(this));
    }

    /* Direkteinstieg auf einer Folgeseite: dezenter Link zu den vorherigen Styles,
       damit oberhalb des Rasters nichts "fehlt". Bewusst ein normaler Link. */
    addPreviousLink() {
      var prevUrl = this.dataset.prevUrl;
      if (!prevUrl || this.currentPage < 2 || !this.grid) return;
      if (document.querySelector('.ana-load-more-prev')) return;

      var link = document.createElement('a');
      link.className = 'ana-load-more-prev';
      link.href = prevUrl;
      link.rel = 'prev';
      link.textContent = this.dataset.labelPrev || '';
      this.grid.parentNode.insertBefore(link, this.grid);
    }

    onClick(event) {
      event.preventDefault();
      this.load(this.btn.getAttribute('href'));
    }

    async load(url) {
      if (!url || this.busy) return;
      this.busy = true;
      this.setBusy(true);

      try {
        var response = await fetch(url);
        if (!response.ok) throw new Error('HTTP ' + response.status);

        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var newGrid = doc.querySelector(GRID_SELECTOR);
        var newControl = doc.querySelector('ana-load-more');
        if (!newGrid || !newGrid.children.length) throw new Error('Kein Produktraster in der Antwort');

        var fragment = document.createDocumentFragment();
        while (newGrid.firstElementChild) {
          fragment.appendChild(newGrid.firstElementChild);
        }
        this.grid.appendChild(fragment);

        this.currentPage = newControl
          ? parseInt(newControl.dataset.currentPage, 10) || this.currentPage + 1
          : this.currentPage + 1;

        this.updateProgress();
        this.updateButton(newControl);

        /* URL mitfuehren, ohne einen History-Eintrag je Klick zu erzeugen */
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', url);
        }
      } catch (error) {
        console.warn('[ANA Load More]', error);
        window.location.href = url;
        return;
      } finally {
        this.busy = false;
        this.setBusy(false);
      }
    }

    updateProgress() {
      var shown = Math.min(this.currentPage * this.pageSize, this.total);

      if (this.countEl) {
        var template = this.dataset.countTemplate || '[shown] / [total]';
        this.countEl.textContent = template
          .replace('[shown]', shown)
          .replace('[total]', this.total);
      }

      if (this.barEl && this.total > 0) {
        this.barEl.style.width = Math.round((shown / this.total) * 100) + '%';
      }
    }

    /* Naechste Seite verlinken — oder den Button durch den Abschlusshinweis ersetzen */
    updateButton(newControl) {
      var nextBtn = newControl ? newControl.querySelector('[data-lm-btn]') : null;

      if (nextBtn) {
        this.btn.setAttribute('href', nextBtn.getAttribute('href'));
        return;
      }

      var end = document.createElement('p');
      end.className = 'ana-load-more__end';
      end.setAttribute('tabindex', '-1');
      end.textContent = this.dataset.labelEnd || '';
      this.btn.replaceWith(end);
      this.btn = null;
      end.focus({ preventScroll: true });
    }

    setBusy(state) {
      if (!this.btn) return;
      if (state) {
        this.btnLabel = this.btn.textContent;
        this.btn.textContent = this.dataset.labelLoading || this.btnLabel;
        this.btn.setAttribute('aria-busy', 'true');
      } else {
        if (this.btnLabel) this.btn.textContent = this.btnLabel;
        this.btn.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('ana-load-more')) {
    customElements.define('ana-load-more', AnaLoadMore);
  }
})();
